import styled from 'styled-components';

import { default as BaseButton } from '@components/Button';

export const ClearAllFiltersCard = styled.button`
  display: flex;
  align-items: center;
  height: 40px;
  justify-content: center;
  gap: 3px;
  width: 100%;
  max-width: 260px;
  padding: 8px 0;
  border: 1px solid ${({ theme }) => theme.palette.grey1100};
  border-radius: 8px;
  background: ${({ theme }) => theme.palette.white};
  color: ${({ theme }) => theme.palette.grey1100};
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const ClearAllFiterWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 24px 24px 24px 0px;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    padding: 0;
  }

  h6 {
    color: ${({ theme }) => theme.palette.grey1100};
    font-size: 20px;
    font-weight: 600;
    line-height: 28px;
    margin-bottom: 0px;
  }
`;

export const Button = styled(BaseButton).attrs({
  type: 'link',
  size: 'small',
})`
  padding: 0px !important;
`;

export const NonCollapsableFilterContainer = styled.div`
  width: 100%;
  height: 54px;
  padding: 15px 13px 15px 15px;
  display: flex;
  justify-content: space-between;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    padding: 0px;
    height: auto;
  }
`;

export const NonCollapsableFilterLeftItems = styled.div`
  font-size: 16px;
  color: ${({ theme }) => theme.palette.brownishGrey};
  display: flex;
  align-items: flex-start;
`;

export const NonCollapsableFilterRightItems = styled.button`
  font-size: 14px;
  color: ${({ theme }) => theme.palette.eclipse};
  display: flex;
  align-items: flex-start;
  background-color: transparent;
  border: none;

  &:disabled {
    opacity: 0.5;
  }
`;

export const NonCollapsableFilterLeftText = styled.div`
  margin-left: 5px;
`;

export const NonCollapsableFilterRightText = styled.div`
  margin-right: 5px;
  line-height: 22.001px;
`;
